import {type RouteLocationStringParam, type RouteRecordRaw} from 'vue-router';

const ProcurementList                 = () => import('../views/procurement/ProcurementList.vue');
const ProcurementEntryEdit            = () => import('../views/procurement/ProcurementEntryEdit.vue');
const ProcurementEntryView            = () => import('../views/procurement/ProcurementEntryView.vue');
const ProcurementInventoryList        = () => import('../views/procurement/inventory/ProcurementInventoryList.vue');
const ProcurementInventoryListEdit    = () => import('../views/procurement/inventory/ProcurementInventoryListEdit.vue');
const ProcurementInventoryListView    = () => import('../views/procurement/inventory/ProcurementInventoryListView.vue');
const ProcurementInventoryListExecute = () => import('../views/procurement/inventory/ProcurementInventoryListExecute.vue');
const ProcurementInventoryOrderList   = () => import('../views/procurement/inventory/ProcurementInventoryOrderList.vue');
const ProcurementInventoryStockList   = () => import('../views/procurement/inventory/ProcurementInventoryStockList.vue');
const ProcurementInventoryHistoryList = () => import('../views/procurement/inventory/ProcurementInventoryHistoryList.vue');

const meta: MetaData = {
    module: 'procurement',
};

const defaultParams = {type: 'own'};

let routes: RouteRecordRaw[] = [
    {
        path: '/procurement',
        redirect: {
            name: 'procurement-list',
            params: defaultParams,
        },
    },
    {
        name: 'procurement-list',
        path: '/procurement/list/:type',
        component: ProcurementList,
        meta,
        props(route: RouteLocationStringParam)
        {
            if (!route?.params?.type)
            {
                return defaultParams;
            }

            const currentViewType = route.params.type as string;

            return {
                type: [
                    'own',
                    'all',
                    'unprocessed',
                    'accepted',
                    'finished',
                    'roles',
                ].includes(currentViewType) ? currentViewType : 'own',
            };
        },
    },
    {
        name: 'procurement-entry-add',
        path: '/procurement/entry/add',
        component: ProcurementEntryEdit,
        meta,
        props()
        {
            return {
                id: 0,
                creation: true,
            };
        },
    },
    {
        name: 'procurement-entry-edit',
        path: '/procurement/entry/edit/:id',
        alias: '/procurement/entry/edit/id/:id',
        component: ProcurementEntryEdit,
        meta,
        props(route: RouteLocationStringParam)
        {
            const id = Number(route.params?.id) || 0;

            return {
                id,
                creation: id === 0,
            };
        },
    },
    {
        name: 'procurement-entry-view',
        path: '/procurement/entry/view/:id',
        alias: '/procurement/entry/view/id/:id',
        component: ProcurementEntryView,
        meta,
        props(route: RouteLocationStringParam)
        {
            return {
                id: Number(route?.params?.id) ?? 0,
            };
        },
    },
    {
        name: 'procurement-inventory-list-add',
        path: '/procurement/inventory/add',
        component: ProcurementInventoryListEdit,
        meta,
        props()
        {
            return {
                id: 0,
                mode: 'add',
            };
        },
    },
    {
        name: 'procurement-inventory-list-edit',
        path: '/procurement/inventory/edit/:id',
        component: ProcurementInventoryListEdit,
        meta,
        props(route: RouteLocationStringParam)
        {
            return {
                id: parseInt(route.params.id) || 0,
                mode: 'edit',
            };
        },
    },
    {
        name: 'procurement-inventory-list-copy',
        path: '/procurement/inventory/copy/:id',
        component: ProcurementInventoryListEdit,
        meta,
        props(route: RouteLocationStringParam)
        {
            return {
                id: parseInt(route.params.id) || 0,
                mode: 'copy',
            };
        },
    },
    {
        name: 'procurement-inventory-list-view',
        path: '/procurement/inventory/view/:id',
        component: ProcurementInventoryListView,
        meta,
        props(route: RouteLocationStringParam)
        {
            return {
                id: parseInt(route.params.id) || 0,
            };
        },
    },
    {
        name: 'procurement-inventory-list-execute',
        path: '/procurement/inventory/execute/id/:id',
        component: ProcurementInventoryListExecute,
        meta,
        props(route: RouteLocationStringParam)
        {
            return {
                id: parseInt(route.params.id) || 0,
            };
        },
    },
    {
        name: 'procurement-inventory-order-list',
        path: '/procurement/inventory/order/:id',
        component: ProcurementInventoryOrderList,
        meta,
        props(route: RouteLocationStringParam)
        {
            return {
                id: parseInt(route.params.id) || 0,
            };
        },
    },
    {
        name: 'procurement-inventory-stock-list',
        path: '/procurement/inventory/stock/:id',
        component: ProcurementInventoryStockList,
        meta,
        props(route: RouteLocationStringParam)
        {
            return {
                id: parseInt(route.params.id) || 0,
            };
        },
    },
    {
        name: 'procurement-inventory-history-list',
        path: '/procurement/inventory/history/:id',
        component: ProcurementInventoryHistoryList,
        meta,
        props(route: RouteLocationStringParam)
        {
            return {
                id: parseInt(route.params.id) || 0,
            };
        },
    },
    /* compatibility routes */
    {
        path: '/procurement/list/:type',
        redirect: {
            name: 'procurement-list',
            params: defaultParams,
        },
    },
    {
        path: '/procurement/entry/edit/:id',
        redirect: {
            name: 'procurement-entry-edit',
        },
    },
    {
        path: '/procurement/entry/edit/id/:id',
        redirect: {
            name: 'procurement-entry-edit',
        },
    },
    {
        path: '/procurement/entry/view/:id',
        redirect: {
            name: 'procurement-entry-edit',
        },
    },
    {
        path: '/procurement/entry/view/id/:id',
        redirect: {
            name: 'procurement-entry-view',
        },
    },
    {
        name: 'procurement-inventory-list',
        path: '/procurement/inventory/list',
        component: ProcurementInventoryList,
        meta,
    },
    {
        path: '/procurement/:wildcard*',
        redirect: {
            name: 'procurement-list',
            params: defaultParams,
        },
    },
];

export default routes;